import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "features/records/components/AttributesForm"
import WithPages from "data/wrappers/WithPages"

const NewPageButton = props => (
    <WithPages>
        {({ createPage, pages }) => (
            <ButtonModal
                button={({ open }) => (
                    <Button icon="plus" color="clear" onClick={open}>
                        New Page
                    </Button>
                )}
                header={() => `New Page`}
                footerClassName={css`
                    justify-content: flex-end;
                `}
                footer={({ close, state }) => [
                    <Button
                        key="create"
                        sideMargin="xsmall"
                        color="success"
                        onClick={() => {
                            var data = state
                            if (data.page_id) {
                                const page = pages.filter(page => page._sid === data.page_id);
                                if (page) {
                                    data.blocks = page[0].blocks
                                }
                            }
                            createPage(data)
                            close()
                        }}
                    >
                        Create
                    </Button>,
                    <Button key="cancel" sideMargin="xsmall" onClick={close}>
                        Cancel
                    </Button>,
                ]}
            >
                {({ setState }) => (
                    <AttributesForm
                        onChange={setState}
                        fields={[
                            { type: "text", label: "Name", api_name: "name" },
                            { type: "text", label: "URL", api_name: "url" },
                            {
                                type: "lookup",
                                label: "App",
                                api_name: "app_id",
                                options: { lookup_target: "app" },
                            },
                            {
                                type: "lookup",
                                label: "Clone Page",
                                api_name: "page_id",
                                options: { lookup_target: "page" },
                            },
                        ]}
                    />
                )}
            </ButtonModal>
        )}
    </WithPages>
)
export default NewPageButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewPageButton.js